export default {
  templates: ({ templates }) => templates,
  workflowTemplateDefaults: ({ workflowTemplateDefaults }) => workflowTemplateDefaults,
};
